<!-- <p>user-favourites works!</p> -->

<div class="user-favourites">
    <div class="alignRow" style="display: flex; margin-bottom: 0.5em;">
        <span style="font-size: large; font-weight: bolder;">Favourite Assets</span>
        <span class="toolbar-spacer"></span>
        <mat-icon *ngIf="hierachy" (click)="searchForAsset()" matTooltip="Add Asset">add</mat-icon>
    </div>
    <div class="middle-div alignRow">
        <span class="toolbar-spacer"></span>
        <mat-icon style="cursor: pointer;" *ngIf="selectedLocation || filteringAccount"
            (click)="filterByAccount($event, true)">close</mat-icon>
        <div class="location-dropdown">
            <ejs-dropdownlist id="locationDropdown" #locationDropdown [dataSource]='accounts' placeholder="Select Account"
                [fields]="accountFields" (change)="filterByAccount($event)" [allowFiltering]="true"
                filterType="contains" popupWidth="200%">
                <ng-template #itemTemplate let-data>
                    <div>
                        <span>{{ data.Name }}</span>
                    </div>
                </ng-template>
            </ejs-dropdownlist>
        </div>
    </div>
    <mat-form-field>
        <mat-label>Search for an Asset</mat-label>
        <input matInput (keyup)="onFiltering($event)" placeholder="" #input>
    </mat-form-field>
    <div class="favourite-item" style="font-size: larger; font-weight: bolder;">
        <span>Account</span>
        <span></span>
        <span>Asset</span>
    </div>
    <ejs-listbox *ngIf="FavouriteAssets && FavouriteAssets.length > 0" [dataSource]="FilteredFavouriteAssets"
        [fields]="fields" class="listbox">
        <ng-template #itemTemplate let-data>
            <div class="favourite-item">
                <span>{{data.AccountName}}</span>
                <img class="assetImage" src="{{imagePathAssets()}}{{data.AssetID}}?{{data.Modified}}"
                    style="max-height: 50px; max-width: 50px;"
                    onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
                    (click)='viewImage(imagePathAssets() + data.AssetID + "?" + data.Modified)'
                    [attr.x-contenttype]="'image/png'" />
                <span>{{data.Name}} - {{data.Description}}</span>
                <button mat-raised-button color="primary" (click)="goToAsset(data)" class="app-icon--goto">
                    <span>Go To Asset</span>
                    <mat-icon/>
                </button>
                <span (click)="removeFavourite(data)" class="alignColumn" matTooltip="Remove Favourite">
                    <mat-icon style="color: gold;">star</mat-icon>
                </span>
            </div>
        </ng-template>
    </ejs-listbox>
</div>
